<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户事件流</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="日期" prop="title">
            <el-date-picker size="small" v-model="queryParams.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @keyup.enter.native="handleQuery"/>
          </el-form-item>
          <el-form-item label="用户ID" prop="title">
            <el-input size="small" v-model.number="queryParams.id" placeholder="请输入用户ID" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-collapse v-loading="loading" v-model="activeNames" @change="handleCollapseChange">
          <el-empty description="暂无数据" v-if="tableData.length === 0"></el-empty>
          <el-collapse-item v-else v-for="item in tableData" :title="handleTitle(item)" :name="item.uid +'-'+ item.eid">
            <el-descriptions class="margin-top" :column="4" size="small" border>
              <el-descriptions-item v-for="(v,k) in item.eventData" v-if="!filterKeys.includes(k)">
                <template slot="label">{{ k }}</template>
                <span size="small">{{ v }}</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-collapse-item>
        </el-collapse>
        <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables"/>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>

import {eventFlow} from "@/api/statistics/event/event";
import {timestampToDate} from "@/api/date";

export default {
  name: 'EventFlow',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 15,
        id: "",
        date: "",
      },
      activeNames: [],
      loading: false,
      total: 0,
      tableData: [],
      filterKeys: ["common",'device_id','time'],
    }
  },
  created() {
    let cache = sessionStorage.getItem("EventFlow")
    if(cache != null){
      this.queryParams = JSON.parse(cache)
    }
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.date === '' || this.queryParams.date == null) {
        this.msgError('请选择日期')
        return
      }
      if (!this.queryParams.id) {
        this.msgError('请输入用户ID')
        return
      }
      sessionStorage.setItem("EventFlow",JSON.stringify(this.queryParams))
      this.getTables()
    },
    getTables() {
      this.loading = true
      eventFlow(this.queryParams).then(res => {
        this.loading = false
        this.tableData = res.data.list
        this.total = res.data.count
        for (let i = 0; i < this.tableData.length; i++) {
          if(this.tableData[i].eventData.common != undefined && this.tableData[i].eventData.common != null){
            let tmp = JSON.parse(this.tableData[i].eventData.common)
            for (const key in tmp) {
              this.tableData[i].eventData[key] = tmp[key]
            }
          }
        }
        console.log(this.tableData)
      })
    },
    handleCollapseChange(val){

    },
    handleTitle(item){
      return timestampToDate(item.time) + " " + item.eventName
    }
  }
}
</script>

<style scoped>
</style>
